// Smooth scrolling helpers. Replaces the react-scroll dependency with the
// platform's own scrollIntoView, which already honours prefers-reduced-motion
// through the scroll-behavior declared in theme.css.

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
}

// Sections can mount a frame or two after navigation completes, so retry
// briefly before giving up.
export function scrollToSectionWhenReady(id, attempts = 20) {
  let left = attempts;
  const tick = () => {
    if (scrollToSection(id) || left <= 0) return;
    left -= 1;
    window.setTimeout(tick, 50);
  };
  tick();
}
